import { Component, OnInit } from '@angular/core';
import { ModalComponent } from '../../modal-service/modal.service';
import { ProductZoomModel } from '../../notes/models/product-zoom-model';

@Component({
  selector: 'app-product-zoom',
  templateUrl: './product-zoom.component.html',
  styleUrls: ['./product-zoom.component.css']
})
export class ProductZoomComponent extends ModalComponent<boolean> implements OnInit {
  currentImage: string;
  btnText: string;

  init(model: ProductZoomModel) {
    this.currentImage = model.imgLink;
    this.btnText = model.btnText;
  }

  //ngOnInit
  ngOnInit() {
  }
}

